// Estado da comanda do PDV (o que o protótipo fazia com o objeto `carrinho`).
import type { FormaPagamento } from "@caixaflow/shared";
import type { ItemCardapio } from "../api/tipos";

export type Comanda = {
  quantidades: Record<string, number>;
  forma: FormaPagamento | null;
  recebidoCentavos: number | null;
};

export const comandaVazia: Comanda = { quantidades: {}, forma: null, recebidoCentavos: null };

export type AcaoComanda =
  | { tipo: "somar"; produtoId: string }
  | { tipo: "diminuir"; produtoId: string }
  | { tipo: "forma"; forma: FormaPagamento }
  | { tipo: "recebido"; centavos: number | null }
  | { tipo: "restaurar"; comanda: Comanda }
  | { tipo: "limpar" };

export function reduzirComanda(c: Comanda, acao: AcaoComanda): Comanda {
  switch (acao.tipo) {
    case "somar":
      return { ...c, quantidades: { ...c.quantidades, [acao.produtoId]: (c.quantidades[acao.produtoId] ?? 0) + 1 } };
    case "diminuir": {
      const quantidades = { ...c.quantidades };
      const q = (quantidades[acao.produtoId] ?? 0) - 1;
      if (q > 0) quantidades[acao.produtoId] = q;
      else delete quantidades[acao.produtoId];
      return { ...c, quantidades };
    }
    case "forma":
      return { ...c, forma: acao.forma, recebidoCentavos: acao.forma === "DINHEIRO" ? c.recebidoCentavos : null };
    case "recebido":
      return { ...c, recebidoCentavos: acao.centavos };
    case "restaurar":
      return acao.comanda;
    case "limpar":
      return comandaVazia;
  }
}

export type ItemDaComanda = { produtoId: string; nome: string; quantidade: number; precoUnitCentavos: number };

/** Itens da comanda na ordem da grade, com o preço atual do cardápio. */
export function itensDaComanda(c: Comanda, cardapio: ItemCardapio[]): ItemDaComanda[] {
  return cardapio
    .filter((i) => (c.quantidades[i.produtoId] ?? 0) > 0)
    .map((i) => ({
      produtoId: i.produtoId,
      nome: i.nome,
      quantidade: c.quantidades[i.produtoId] ?? 0,
      precoUnitCentavos: i.precoCentavos,
    }));
}

/**
 * Quanto ainda dá para vender de um produto neste aparelho: o saldo do servidor menos o que
 * já saiu em vendas guardadas na fila e o que está na comanda. `null` = sem limite.
 */
export function disponivel(
  item: ItemCardapio,
  vendidoNaFila: number,
  naComanda: number,
  permiteEstoqueNegativo: boolean,
): number | null {
  if (permiteEstoqueNegativo) return null;
  return item.saldo - vendidoNaFila - naComanda;
}
